import React from 'react';
import PropTypes from 'prop-types';

import LinkWithSearch from '../LinkWithSearch';

const AppLink = props => {
  const {
    app: {
      isIntegration,
      links: { detail }
    },
    children
  } = props;
  return (
    <Choose>
      <When condition={isIntegration || detail.indexOf('http') > -1}>
        <span data-testid="AppLink_ExternalLink">
          <a href={detail} {...props}>
            {children}
          </a>
        </span>
      </When>
      <Otherwise>
        <span data-testid="AppLink_InternalLink">
          <LinkWithSearch pathname={detail} {...props}>
            {children}
          </LinkWithSearch>
        </span>
      </Otherwise>
    </Choose>
  );
};

AppLink.propTypes = {
  app: PropTypes.shape({
    isIntegration: PropTypes.bool.isRequired,
    links: PropTypes.shape({
      detail: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  children: PropTypes.node.isRequired
};

export default AppLink;
